import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1c3df4f7"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=1c3df4f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports